import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Send, MessageSquare, Clock } from 'lucide-react';

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen bg-midnight py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-serif font-bold mb-6">Contact Us</h1>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            Have questions about your reading or our collection? Our celestial support team is here to guide you.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Contact Info */}
          <div className="lg:col-span-1 space-y-6">
            {[
              { icon: <Mail className="w-6 h-6 text-gold" />, title: "Email Us", detail: "hello@astrovidya.net", sub: "Response within 24 hours" },
              { icon: <Phone className="w-6 h-6 text-gold" />, title: "Call Us", detail: "+91 98765 43210", sub: "Mon-Fri, 10am - 6pm IST" },
              { icon: <MapPin className="w-6 h-6 text-gold" />, title: "Visit Us", detail: "Boomtech Solution Private Limited", sub: "India" }
            ].map((item, idx) => (
              <div key={idx} className="p-8 bg-white/5 border border-white/10 rounded-2xl flex items-start space-x-4">
                <div className="mt-1">{item.icon}</div>
                <div>
                  <h3 className="text-white font-serif font-bold mb-1">{item.title}</h3>
                  <p className="text-gold font-bold text-sm mb-1">{item.detail}</p>
                  <p className="text-gray-500 text-xs">{item.sub}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-white/5 border border-white/10 p-8 md:p-12 rounded-3xl backdrop-blur-md"
            >
              <h2 className="text-2xl font-serif font-bold mb-8 flex items-center">
                <MessageSquare className="w-6 h-6 mr-3 text-gold" />
                Send a Message
              </h2>
              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label className="text-xs font-bold uppercase tracking-widest text-gray-400">Full Name</label>
                    <input type="text" className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-xl focus:border-gold outline-none text-white" placeholder="John Doe" required />
                  </div>
                  <div className="space-y-2">
                    <label className="text-xs font-bold uppercase tracking-widest text-gray-400">Email Address</label>
                    <input type="email" className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-xl focus:border-gold outline-none text-white" placeholder="john@example.com" required />
                  </div>
                </div>
                <div className="space-y-2">
                  <label className="text-xs font-bold uppercase tracking-widest text-gray-400">Subject</label>
                  <select className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-xl focus:border-gold outline-none text-white appearance-none">
                    <option className="bg-midnight">General Inquiry</option>
                    <option className="bg-midnight">Order Support</option>
                    <option className="bg-midnight">Birth Chart Question</option>
                    <option className="bg-midnight">Jewelry Customization</option>
                  </select>
                </div>
                <div className="space-y-2">
                  <label className="text-xs font-bold uppercase tracking-widest text-gray-400">Message</label>
                  <textarea rows={5} className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-xl focus:border-gold outline-none text-white" placeholder="How can we help you today?" required />
                </div>
                <button className="w-full py-5 bg-gold text-midnight font-bold rounded-xl hover:bg-white transition-all flex items-center justify-center group shadow-lg shadow-gold/10">
                  Send Message
                  <Send className="ml-2 w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
